const PLANTING_CYCLE = 'PlantingCycle';

export function getPlantingCycleProducts(productsList) {
  return (productsList || []).filter(item => item?.product?.type === PLANTING_CYCLE);
}

export function getPlantingCycleIds(productsList) {
  return getPlantingCycleProducts(productsList).map(item => item.product.id);
}

export function resolveSelectedCycleId(currentId, ids) {
  const list = ids || [];
  if (currentId != null && list.includes(currentId)) {
    return currentId;
  }
  return list.length > 0 ? list[0] : null;
}
